<div class="modal-body relative">
  <header class="header modal-header flex flex-col gap-2 place-content-between">
    <div class="flex justify-between">
      <h2 class="modal-headline">Export Downloads</h2>
      <button mat-icon-button mat-dialog-close class="button-close">
        <mat-icon class="material-icons-outlined" aria-hidden="true">close</mat-icon>
        <span class="sr-only" i18n>Close</span>
      </button>
    </div>
  </header>
  <form [formGroup]="exportDownloadsForm">
    <div class="flex-col gap-3 bg-white h-full">
      <div class="modal-main flex justify-between w-full !min-h-[300px]">
        <div class="flex flex-col mx-4 w-full max-h-[450px] overflow-scroll">
          <mat-checkbox (change)="checkAll($event.checked)" [indeterminate]="someComplete()" [checked]="allComplete">
            <span *ngIf="!allComplete">Select All ({{ assets.length }})</span>
            <span *ngIf="allComplete">All assets ({{ assets.length }})</span>
          </mat-checkbox>
          <mat-checkbox class="ml-5" *ngFor="let asset of assets" (change)="checkboxClick(asset._id)" [checked]="getCheckedStatus(asset._id)">
            <span>{{ asset.name }}</span>
          </mat-checkbox>
        </div>
      </div>
    </div>
  </form>
  <div class="modal-footer flex flex-col !justify-between w-full gap-4 !items-end">
    <mat-error *ngIf="downloadDataFlag">No download data for selected assets available.</mat-error>
    <button (click)="onSubmit()" class="button-primary ml-auto" mat-flat-button [attr.data-test-id]="'asset-upload_button_upload'" [disabled]="!exportDownloadsForm.valid || downloadDataFlag">
      <ng-container i18n>Export Excel</ng-container>
      <mat-icon class="material-icons-outlined ml-2">upload_file</mat-icon>
    </button>
  </div>
</div>
